module.exports = __webpack_public_path__ + "img/photo-3.543bcb7a.jpg";